var map = {
	"./": [
		25755
	],
	"./Booklet/Cover1": [
		80828
	],
	"./Booklet/Cover1.ts": [
		80828
	],
	"./Booklet/Cover2": [
		50176
	],
	"./Booklet/Cover2.ts": [
		50176
	],
	"./Booklet/Cover3": [
		47952
	],
	"./Booklet/Cover3.ts": [
		47952
	],
	"./Booklet/Cover4": [
		53279
	],
	"./Booklet/Cover4.ts": [
		53279
	],
	"./Booklet/Image1": [
		88834
	],
	"./Booklet/Image1.ts": [
		88834
	],
	"./Booklet/Image2": [
		46156
	],
	"./Booklet/Image2.ts": [
		46156
	],
	"./Booklet/Image3": [
		51010
	],
	"./Booklet/Image3.ts": [
		51010
	],
	"./Booklet/Mixed1": [
		9082
	],
	"./Booklet/Mixed1.ts": [
		9082
	],
	"./Booklet/Mixed2": [
		52531
	],
	"./Booklet/Mixed2.ts": [
		52531
	],
	"./Booklet/Quote1": [
		48493
	],
	"./Booklet/Quote1.ts": [
		48493
	],
	"./Booklet/Quote2": [
		81183
	],
	"./Booklet/Quote2.ts": [
		81183
	],
	"./Booklet/Quote3": [
		32553
	],
	"./Booklet/Quote3.ts": [
		32553
	],
	"./Booklet/SimpleLayout": [
		72715,
		715
	],
	"./Booklet/SimpleLayout.ts": [
		72715,
		715
	],
	"./Booklet/Text1": [
		62821
	],
	"./Booklet/Text1.ts": [
		62821
	],
	"./Booklet/Text2": [
		86637
	],
	"./Booklet/Text2.ts": [
		86637
	],
	"./Examples/Example1/variant1": [
		75283,
		283
	],
	"./Examples/Example1/variant1.ts": [
		75283,
		283
	],
	"./Examples/Example1/variant2": [
		50505,
		505
	],
	"./Examples/Example1/variant2.ts": [
		50505,
		505
	],
	"./Examples/Example1/variant3": [
		9054,
		54
	],
	"./Examples/Example1/variant3.ts": [
		9054,
		54
	],
	"./Examples/Example1/variant4": [
		1322,
		322
	],
	"./Examples/Example1/variant4.ts": [
		1322,
		322
	],
	"./Examples/Example2/variant1": [
		73649,
		649
	],
	"./Examples/Example2/variant1.ts": [
		73649,
		649
	],
	"./Examples/Example2/variant2": [
		97550,
		550
	],
	"./Examples/Example2/variant2.ts": [
		97550,
		550
	],
	"./Examples/Example2/variant3": [
		4074,
		74
	],
	"./Examples/Example2/variant3.ts": [
		4074,
		74
	],
	"./Examples/Example2/variant4": [
		82710,
		710
	],
	"./Examples/Example2/variant4.ts": [
		82710,
		710
	],
	"./Examples/Example3/variant1": [
		8989,
		989
	],
	"./Examples/Example3/variant1.ts": [
		8989,
		989
	],
	"./Examples/Example3/variant2": [
		6670,
		792
	],
	"./Examples/Example3/variant2.ts": [
		6670,
		792
	],
	"./Examples/Example3/variant3": [
		34282,
		282
	],
	"./Examples/Example3/variant3.ts": [
		34282,
		282
	],
	"./Examples/Example3/variant4": [
		70225,
		225
	],
	"./Examples/Example3/variant4.ts": [
		70225,
		225
	],
	"./Examples/Example4/variant1": [
		17421,
		421
	],
	"./Examples/Example4/variant1.ts": [
		17421,
		421
	],
	"./Examples/Example4/variant2": [
		64875,
		875
	],
	"./Examples/Example4/variant2.ts": [
		64875,
		875
	],
	"./Examples/Example4/variant3": [
		13949,
		949
	],
	"./Examples/Example4/variant3.ts": [
		13949,
		949
	],
	"./Examples/Example4/variant4": [
		93670,
		670
	],
	"./Examples/Example4/variant4.ts": [
		93670,
		670
	],
	"./Examples/Example5/variant1": [
		13238,
		238
	],
	"./Examples/Example5/variant1.ts": [
		13238,
		238
	],
	"./Examples/Example5/variant2": [
		14429,
		429
	],
	"./Examples/Example5/variant2.ts": [
		14429,
		429
	],
	"./Examples/Example5/variant3": [
		37096,
		96
	],
	"./Examples/Example5/variant3.ts": [
		37096,
		96
	],
	"./Examples/Example5/variant4": [
		18494,
		494
	],
	"./Examples/Example5/variant4.ts": [
		18494,
		494
	],
	"./Examples/Example6/variant1": [
		73823,
		823
	],
	"./Examples/Example6/variant1.ts": [
		73823,
		823
	],
	"./Examples/Example6/variant2": [
		28536,
		536
	],
	"./Examples/Example6/variant2.ts": [
		28536,
		536
	],
	"./Examples/Example6/variant3": [
		81986,
		986
	],
	"./Examples/Example6/variant3.ts": [
		81986,
		986
	],
	"./Examples/Example6/variant4": [
		52042,
		42
	],
	"./Examples/Example6/variant4.ts": [
		52042,
		42
	],
	"./Presentation/Cover1": [
		67563
	],
	"./Presentation/Cover1.ts": [
		67563
	],
	"./Presentation/Cover2": [
		29198
	],
	"./Presentation/Cover2.ts": [
		29198
	],
	"./Presentation/Cover3": [
		93813
	],
	"./Presentation/Cover3.ts": [
		93813
	],
	"./Presentation/Image1": [
		61000
	],
	"./Presentation/Image1.ts": [
		61000
	],
	"./Presentation/Image2": [
		21408
	],
	"./Presentation/Image2.ts": [
		21408
	],
	"./Presentation/Mixed1": [
		10769
	],
	"./Presentation/Mixed1.ts": [
		10769
	],
	"./Presentation/Mixed2": [
		33371
	],
	"./Presentation/Mixed2.ts": [
		33371
	],
	"./Presentation/Quote1": [
		39296
	],
	"./Presentation/Quote1.ts": [
		39296
	],
	"./Presentation/Quote2": [
		18081
	],
	"./Presentation/Quote2.ts": [
		18081
	],
	"./Presentation/Text1": [
		83549
	],
	"./Presentation/Text1.ts": [
		83549
	],
	"./Presentation/Text2": [
		56860
	],
	"./Presentation/Text2.ts": [
		56860
	],
	"./Presentation/Text3": [
		97247
	],
	"./Presentation/Text3.ts": [
		97247
	],
	"./Presentation/Text4": [
		36753
	],
	"./Presentation/Text4.ts": [
		36753
	],
	"./Sheet/2Text2Image": [
		56564
	],
	"./Sheet/2Text2Image.ts": [
		56564
	],
	"./Sheet/3Image": [
		90284
	],
	"./Sheet/3Image.ts": [
		90284
	],
	"./Sheet/Image3Text": [
		60808
	],
	"./Sheet/Image3Text.ts": [
		60808
	],
	"./Sheet/ImageQuote": [
		76730
	],
	"./Sheet/ImageQuote.ts": [
		76730
	],
	"./Sheet/ImageText": [
		800
	],
	"./Sheet/ImageText.ts": [
		800
	],
	"./Sheet/Quote2Image": [
		5284
	],
	"./Sheet/Quote2Image.ts": [
		5284
	],
	"./Sheet/Quote4Image": [
		82624
	],
	"./Sheet/Quote4Image.ts": [
		82624
	],
	"./Sheet/Text": [
		98042
	],
	"./Sheet/Text.ts": [
		98042
	],
	"./Sheet/Text2Image": [
		60436
	],
	"./Sheet/Text2Image.ts": [
		60436
	],
	"./Sheet/Text4Image": [
		49626
	],
	"./Sheet/Text4Image.ts": [
		49626
	],
	"./Sheet/Title2Paragraph": [
		47630
	],
	"./Sheet/Title2Paragraph.ts": [
		47630
	],
	"./Sheet/TitleImageQuote": [
		40108
	],
	"./Sheet/TitleImageQuote.ts": [
		40108
	],
	"./Sheet/TitleParagraph": [
		9637
	],
	"./Sheet/TitleParagraph.ts": [
		9637
	],
	"./Story/2Body2Images": [
		93715
	],
	"./Story/2Body2Images.ts": [
		93715
	],
	"./Story/Body": [
		2560
	],
	"./Story/Body.ts": [
		2560
	],
	"./Story/CaptionHeadlineBody": [
		91615
	],
	"./Story/CaptionHeadlineBody.ts": [
		91615
	],
	"./Story/Headline2Images": [
		63579
	],
	"./Story/Headline2Images.ts": [
		63579
	],
	"./Story/Headline4Images": [
		62258
	],
	"./Story/Headline4Images.ts": [
		62258
	],
	"./Story/HeadlineImage1": [
		20229
	],
	"./Story/HeadlineImage1.ts": [
		20229
	],
	"./Story/HeadlineImage2": [
		68260
	],
	"./Story/HeadlineImage2.ts": [
		68260
	],
	"./Story/HeadlineImage3": [
		18812
	],
	"./Story/HeadlineImage3.ts": [
		18812
	],
	"./Story/ImageCaptionHeadline": [
		26940
	],
	"./Story/ImageCaptionHeadline.ts": [
		26940
	],
	"./Story/ImageHeadlineBody": [
		78994
	],
	"./Story/ImageHeadlineBody.ts": [
		78994
	],
	"./Story/Quote": [
		89035
	],
	"./Story/Quote.ts": [
		89035
	],
	"./Story/QuoteCaption": [
		74515
	],
	"./Story/QuoteCaption.ts": [
		74515
	],
	"./Story/Sequence": [
		57903,
		903
	],
	"./Story/Sequence.ts": [
		57903,
		903
	],
	"./index": [
		25755
	],
	"./index.ts": [
		25755
	],
	"./types": [
		90748,
		748
	],
	"./types.ts": [
		90748,
		748
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 93401;
module.exports = webpackAsyncContext;